import React from "react";

const Health: React.FC = () => {
    return (
      <>
        OK
      </>
    );
}

export default Health;